<template>
    <div class="snapshot-mb standard" :style="containerStyle">
        <!-- data content start -->
        <div v-show="showMarketReportData || showMarketComing">
            <!-- swiper start -->
            <div class="swipe_box">
                <div class="swipe_content">
                    <!-- slide start -->
                    <Swiper class="slide_container" v-bind="options">
                        <Slide class="swipe_item">
                            <snap-circle
                                :params="soldListing"
                                :hasRecentSold="hasRecentSold"
                            />
                        </Slide>

                        <Slide class="swipe_item">
                            <snap-circle
                                :params="avgSalePrice"
                                :hasRecentSold="hasRecentSold"
                            />
                        </Slide>

                        <Slide class="swipe_item">
                            <snap-circle
                                :params="avgDaysOnMarket"
                                :hasRecentSold="hasRecentSold"
                            />
                        </Slide>
                    </Swiper>
                    <!-- slide end -->

                    <button class="swipt_opts left_btn">
                        <span class="iconfont icon-arrow-left"></span>
                    </button>
                    <button class="swipt_opts right_btn">
                        <span class="iconfont icon-arrow-right"></span>
                    </button>
                </div>
                <div
                    class="loading_container"
                    v-show="showMarketReportLoading || showMarketComing"
                >
                    <Loading />
                </div>
            </div>
            <!-- swiper end -->
        </div>
        <!-- data content end -->
        <!-- coming soon start -->
        <!-- <div class="coming_container" v-show="showMarketComing">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v3-img-no-market@2x.png"
                alt=""
            />
            <div class="desc">coming soon</div>
        </div> -->
        <!-- coming soon end -->
        <!-- No Location start -->
        <div class="location_tips_container" v-show="showMarketNoLocation">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v3-img-no-market@2x.png"
                alt
            />
            <div class="desc">
                {{ $t('md-snapshot-search.pleaseInputAValid') }}
            </div>
        </div>
        <!-- No Location end -->
        <!-- no data start -->
        <div class="no_data" v-show="showMarketNoData">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v3-img-no-market@2x.png"
                alt
            />
            <div class="desc">
                {{ noDataText }}
            </div>
        </div>
        <!-- no data end -->
    </div>
</template>

<script>


import { mapState, mapActions } from '@/store/helpers';


import Circle from './circle';
import Loading from '../../../../../components/loading';

import MoreBtnCommon from '../../../_mixins/more-btn/common';
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
export default {
    name: 'report-mb',
    components: {
        'snap-circle': Circle,
        Swiper,
        Slide: SwiperSlide,
        Loading
    },
    props: {
        soldListing: {
            required: true
        },
        avgSalePrice: {
            required: true
        },
        avgDaysOnMarket: {
            required: true
        }
    },
    mixins: [MoreBtnCommon],
    computed: {
        ...mapState({
            "showMarketReportData": "showMarketReportData",
            "showMarketReportLoading": "showMarketReportLoading",
            "showMarketNoLocation": "showMarketNoLocation",
            "showMarketComing": "showMarketComing",
            "showMarketNoData": "showMarketNoData"
        }),
        // container  style of
        containerStyle() {
            return { height: `${this.needMore ? 395 : 315}px` };
        },
        hasRecentSold() {
            return this.soldListing?.status !== 3;
        },
        options() {
            return fixSwiperOptions({
                navigation: {
                    closest: '.swipe_content',
                    nextEl: '.right_btn',
                    prevEl: '.left_btn',
                    disabledClass: 'disabled'
                }
            });
        }
    }
};
</script>

<style lang="scss">
.snapshot-mb.standard {
    box-sizing: border-box;
    padding: 40px 0 20px;
    background: #fff;
    .more {
        background-color: var(--color-theme);
        width: 345px;
        height: 40px;
        line-height: 40px;
        margin: 0 auto;
        margin-top: 40px;
        font-size: 16px;
        color: #ffffff;
        display: flex;
        align-content: center;
        justify-content: center;
        p {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    .swipe_box {
        .swipt_opts {
            position: absolute;
            top: 50%;
            z-index: var(--level-sublow);
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f8f9fd;
            transform: translateY(50%);
            &:active {
                color: white;
                background-color: var(--color-theme);
            }
            &.left_btn {
                left: 0px;
            }
            &.right_btn {
                right: 0px;
            }
            &.disabled {
                display: none;
            }
        }
        .loading_container {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: var(--level-low);
            background: rgba(255, 255, 255, 0.6);
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    /**  Display of empty state, etc.  */
    .coming_container,
    .location_tips_container,
    .no_data {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .pic {
            width: 220px;
            height: 130px;
        }
        .desc {
            margin-top: 20px;
            font-size: 16px;
            padding: 0 20px;
            text-align: center;
            color: var(--color-holder);
        }
    }
}

</style>
